import { Entity, EntityEdge } from './types';

const hasEntityEdgeWithId = <T extends Entity>(edges: EntityEdge<T>[], id: T['id']) =>
  !!edges.find((edge) => edge.nodeId === id);

export const entityEdgesWithoutSubset: <T extends Entity>(
  edges: EntityEdge<T>[],
  subset: EntityEdge<T>[]
) => EntityEdge<T>[] = (edges, subset) => edges.filter((edge) => !hasEntityEdgeWithId(subset, edge.nodeId));
